import React from "react";

// bea-zoom https://codesandbox.io/s/how-to-call-fitbounds-and-getbounds-in-react-leaflet-1m50m?file=/src/Map.js
// import {createRef} from "react";

import PropTypes from 'prop-types';
import { Map as LeafletMap, TileLayer, CircleMarker, Marker, Popup } from 'react-leaflet';
import { Spin, Divider, Icon, Popover } from 'antd';
import { inject, observer } from 'mobx-react';
import { Rnd } from 'react-rnd';
import L, { latLngBounds} from 'leaflet';

import 'leaflet-easyprint';
// import exports from 'highcharts';
// import zipcelx from 'zipcelx';
// import xlsx from 'node-xlsx';
// var excel = require('excel4node');

// import { Popup } from "react-leaflet";

global.Highcharts = require('highcharts');
require('highcharts/modules/exporting')(global.Highcharts);
require('highcharts/modules/offline-exporting')(global.Highcharts);
require('highcharts/modules/export-data')(global.Highcharts);
const ReactHighcharts = require('react-highcharts');

const Lines = props => {
  const poiLat = props.poi[0];
  const poiLng = props.poi[1];
  const poiCode = props.poiCode;
  const meanPoeArray = props.meanPoeData.slice();
  const p02PoeArray = props.p02PoeData.slice();
  const p16PoeArray = props.p16PoeData.slice();
  const p50PoeArray = props.p50PoeData.slice();
  const p84PoeArray = props.p84PoeData.slice();
  const p98PoeArray = props.p98PoeData.slice();
  const meanMihArray = props.meanMihData.slice();
  const p02MihArray = props.p02MihData.slice();
  const p16MihArray = props.p16MihData.slice();
  const p50MihArray = props.p50MihData.slice();
  const p84MihArray = props.p84MihData.slice();
  const p98MihArray = props.p98MihData.slice();

  const exportMenuItems = global.Highcharts.getOptions().exporting.buttons.contextButton.menuItems;
  exportMenuItems.splice(8, 3); // Remove options to display in div
  exportMenuItems.splice(4, 1); // Remove options to display in div

  /*
      0.00002,
    0.00005,
    0.0002,
    0.0001,

   */
  const poETicks = [
    0.00049,
    0.0005,
    0.001,
    0.002,
    0.005,
    0.01,
    0.02,
    0.05,
    0.1,
    0.2,
    0.5,
    1.0,
  ];

  const slavePoETicks = [
    0.0005,
    0.001,
    0.002,
    0.005,
    0.01,
    0.02,
    0.05,
    0.1,
    0.2,
    0.5,
    1.0,
  ];

  const poeticktext = {
    1.0: '1e0',
    0.5: '5e-1',
    0.2: '2e-1',
    0.1: '1e-1',
    0.05: '5e-2',
    0.02: '2e-2',
    0.01: '1e-2',
    0.005: '5e-3',
    0.002: '2e-3',
    0.001: '1e-3',
    0.0005: '5e-4',
    0.0002: '2e-4',
    0.0001: '1e-4',
    0.00005: '5e-5',
    0.00002: '2e-5',
  };

  // const poeticktext = {
  //   1: '1e-0',
  //   0.1: '1e-1',
  //   0.05: '5e-2',
  //   0.02: '2e-2',
  //   0.01: '1e-2',
  //   0.005: '5e-3',
  // };

  const mihTicks = [
    0.5,
    1,
    2,
    5,
    10,
    20,
    50
  ];
  // const mihTicks = Math.pow(10, [0.5, 1, 2, 5, 10, 20, 50]);

  const mihTickText = {
    0.5: '0.5',
    1: '1',
    2: '2',
    5: '5',
    10: '10',
    20: '20',
    50: '50',
  }


  const config = {
    styledMode: true,
    // plotOptions: {
    //   series: {
    //     pointStart: 0.5,
    //     pointEnd: 50
    //   }
    // },
    title: {
      text: `Hazard curves at: Lat ${poiLat}, Lon ${poiLng} POI id: ${poiCode}`,
      style: { fontSize: 15 },
    },
    // subtitle: {
    //   text: `Hazard curves generated for POI located at Lat:${poiLat} Lng:${poiLng}`,
    //   style: { fontSize: 11 },
    // },
    chart: {
      height: `${(9 / 16) * 100}%`, // 16:9 ratio
    },
    credits: {
      enabled: false,
      href: 'http://www.i4.com.tr',
      text: 'Made with ♥ by i4',
    },
    tooltip: {
      formatter() {
        return `Values for datapoint on <b>${this.series.name}</b><br/>MIH: <b>${
          this.x
        }m</b><br/>PoE: <b>${this.y.toPrecision(4)}</b>`;
      },
    },
    exporting: {
      filename: `hazard_curve_for_${poiCode}`,
    },

    xAxis: {
      type: 'logarithmic',
      tickInterval: 1,
      tickPositions: mihTicks.map((v) => Math.log10(v)),

      // max: 50,
      // min: 0.5,

      // tikPositions: Math.pow(10, mihTicks),
      // tickPositions: mihTicks,
      // tickValues: Math.pow(10, mihTicks),
      //
      // labels: {
      //   formatter() {
      //     return this.value; //mihTickText[this.value];
      //   }
      // },

      //// tickInterval: 0.2,
      // gridLineWidth: 1,
      title: {
        enabled: true,
        text: 'Maximum Inundation Height (MIH, meters) ',
        style: {
          fontStyle: 'italic',
        },
      },
    },
    yAxis: [
      {
        type: 'logarithmic',
        minorTickInterval: 0.1,
        minorGridLineColor: '#EEEEEE',
        gridLineColor: '#EEEEEE',
        tickInterval: 0.1,
        tickPositions: poETicks.map((v) => Math.log10(v)),

        // tickInterval: 0.05,
        // startOnTick: true,
        // minPadding: 0,
        // tickPositions: poETicks.map((v) => Math.log10(v)),

        labels: {
          formatter() {
            if (this.value) {
              return poeticktext[this.value];
            }
            else {
              return '';
            }
          }
        },
        max: 1,
        min: 0.005,

        // gridLineColor: '#197F07',
        // minorTickInterval: 0.1,

        title: {
          enabled: true,
          text: 'Probability of Exceedance (PoE) in 50 years',
          style: {
            fontStyle: 'italic',
          },
        },
      },
      {
        // slave axis
        type: 'logarithmic',
        tickPositions: slavePoETicks.map((v) => Math.log10(v)),
        linkedTo: 0,
        opposite: true,
        gridLineColor: '#777777',
        title: {
          enabled: true,
          text: 'Average Return Period (ARP, years)',
          style: {
            fontStyle: 'italic',
          },
        },
        labels: {
          formatter() {
            if (this.value === 1) {
              return 0;
            } else if (this.value === 0.5) {
              return 72;
            } else if (this.value === 0.2) {
              return 224;
            } else if (this.value === 0.1) {
              return 475;
            } else if (this.value === 0.05) {
              return 975;
            } else if (this.value === 0.02) {
              return 2475;
            } else if (this.value === 0.01) {
              return 4975;
            } else if (this.value === 0.005) {
              return 9975;
            } else if (this.value === 0.002) {
              return 24975;
            } else if (this.value === 0.001) {
              return 49975;
            }else if (this.value === 0.0005) {
              return 99975;
            } else {
              return '';
            }
          },
        },
      },
    ],
    series: [
      {
        name: 'Mean',
        data: meanPoeArray.map((poe, index) => [parseFloat(meanMihArray[index]), poe]),
        color: '#1890ff',
        lineWidth: 5,
        marker: {
          radius: 6,
        },
      },
      {
        name: 'p02',
        data: p02PoeArray.map((poe, index) => [parseFloat(p02MihArray[index]), poe]),
        color: '#088d43',
      },
      {
        name: 'p16',
        data: p16PoeArray.map((poe, index) => [parseFloat(p16MihArray[index]), poe]),
        color: '#ffa500',
      },
      {
        name: 'p50',
        data: p50PoeArray.map((poe, index) => [parseFloat(p50MihArray[index]), poe]),
        color: '#b33030',
      },
      {
        name: 'p84',
        data: p84PoeArray.map((poe, index) => [parseFloat(p84MihArray[index]), poe]),
        color: '#ffa500',
      },
      {
        name: 'p98',
        data: p98PoeArray.map((poe, index) => [parseFloat(p98MihArray[index]), poe]),
        color: '#088d43',
      },
      {
        name: 'ghost',
        data: [1, 0.005].map((poe, index) => [[0.5, 50][index], poe]),
        color: '#FFFFFF',
        showInLegend: false,
        lineWidth: 0,
        opacity: 0,
        marker: {
          radius: 0,
        },
      },
    ],
  };

  return <ReactHighcharts config={config} />;
};

Lines.propTypes = {
  poi: PropTypes.object.isRequired,
  poiCode: PropTypes.object.isRequired,
  meanPoeData: PropTypes.object.isRequired,
  p02PoeData: PropTypes.object.isRequired,
  p16PoeData: PropTypes.object.isRequired,
  p50PoeData: PropTypes.object.isRequired,
  p84PoeData: PropTypes.object.isRequired,
  p98PoeData: PropTypes.object.isRequired,
  meanMihData: PropTypes.object.isRequired,
  p02MihData: PropTypes.object.isRequired,
  p16MihData: PropTypes.object.isRequired,
  p50MihData: PropTypes.object.isRequired,
  p84MihData: PropTypes.object.isRequired,
  p98MihData: PropTypes.object.isRequired,
};

// let popupRef = useRef();
//

const CirclePopup = (props) => {
  // eslint-disable-next-line prefer-destructuring,react/prop-types
  const detail = props.detail;
  const mapType = props.mapType;
  if (mapType === 'hazard') {
    if (['extrapolated', 'interpolated'].indexOf(detail.method) >= 0) {
        return (
        <Popup>
          <div>
            <span>
              <h2>
                Poi code: <b>{detail.poiCode}</b>
              </h2>
              <h2>
                MIH {detail.method} value: <b>{detail.mihValue}</b>
              </h2>
            </span>
            <span>
              <h2>
                MIH lower: <b>{detail.mihLower}</b>
              </h2>
            </span>
            <span>
              <h2>
                MIH upper: <b>{detail.mihUpper}</b>
              </h2>
            </span>
            <span>
              <h2>
                PoE value: <b>{detail.poeValue}</b>
              </h2>
            </span>
            <span>
              <h2>
                PoE lower: <b>{detail.poeLower}</b>
              </h2>
            </span>
            <span>
              <h2>
                PoE upper: <b>{detail.poeUpper}</b>
              </h2>
            </span>
          </div>
        </Popup>
      );
    }
    else {
      return (
        <Popup>
          <div>
            <span>
              <h2>
                Poi code: <b>{detail.poiCode}</b>
              </h2>
              <h2>
                MIH value: <b>{detail.mihValue}</b>
              </h2>
            </span>
            <span>
              <h2>
                PoE value: <b>{detail.poeValue}</b>
              </h2>
            </span>
          </div>
        </Popup>
      );
    }
  }
  if (['extrapolated', 'interpolated'].indexOf(detail.method) >= 0) {
    return (
      <Popup>
        <div>
            <span>
              <h2>
                Poi code: <b>{detail.poiCode}</b>
              </h2>
              <h2>
                PoE {detail.method} value: <b>{detail.poeValue}</b>
              </h2>
            </span>
          <span>
              <h2>
                MIH lower: <b>{detail.mihLower}</b>
              </h2>
            </span>
          <span>
              <h2>
                MIH upper: <b>{detail.mihUpper}</b>
              </h2>
            </span>
          <span>
              <h2>
                MIH value: <b>{detail.mihValue}</b>
              </h2>
            </span>
          <span>
              <h2>
                PoE lower: <b>{detail.poeLower}</b>
              </h2>
            </span>
          <span>
              <h2>
                PoE upper: <b>{detail.poeUpper}</b>
              </h2>
            </span>
        </div>
      </Popup>
    );
  }
  else {
    return (
      <Popup>
        <div>
            <span>
              <h2>
                Poi code: <b>{detail.poiCode}</b>
              </h2>
              <h2>
                PoE {detail.method} value: <b>{detail.poeValue}</b>
              </h2>
            </span>
          <span>
              <h2>
                MIH value: <b>{detail.mihValue}</b>
              </h2>
          </span>
        </div>
      </Popup>
    );
  }
};

const Circles = (props) => {
  const circleInfo = props.circleData.slice();

  if (circleInfo.length !== 0) {
    console.log("circle info")
    console.log(circleInfo[0])
    console.log(circleInfo[1])
    console.log(circleInfo[2])
    const currentMaptype = props.map.props.dataStore.currentMaptype;
    // const bbb = props.map.props.dataStore.getcurrentMaptype();
    const circles = circleInfo[0].map((color, index) => (
      <CircleMarker
        center={[circleInfo[1][index][0], circleInfo[1][index][1]]}
        key={index}
        radius="5"
        opacity="1"
        fillOpacity="0.5"
        stroke
        color={color}
        onMouseOver={(e) => {
          e.target.openPopup();
        }}
        onMouseOut={(e) => {
          e.target.closePopup();
        }}
        onClick={(e) => {
          props.map.getClickedLoc(e, circleInfo[2][index].poiCode);
        }}
      >
        <CirclePopup mapType={currentMaptype} detail={circleInfo[2][index]} />
      </CircleMarker>
    ));
    return circles;
  }


  return <span />;
};

Circles.propTypes = {
  circleData: PropTypes.object.isRequired,
};

const curveInfoContent = (
  <div>
    - This window is <b>resizable</b> and <b>draggable</b>.<br />- You can <b>filter</b> the curves clicking them on
    legend.<br />- <b>Export</b> options are under the top-right dropdown.
  </div>
);

(function(H) {
  let pick = H.pick
  H.wrap(H.Chart.prototype, 'getCSV', function(p, useLocalDecimalPoint) {
    var matrix = [[]];
    const poeFixedValues = [
      1.0, 0.5, 0.2, 0.1, 0.05, 0.02, 0.01, 0.005, 0.002, 0.001, 0.0005]; // , 0.0002, 0.0001, 0.00005, 0.00002];

    var columns = ['poe', 'mih_mean', 'mih_p02', 'mih_p16', 'mih_p50', 'mih_84', 'mih_98']
    matrix [0] = columns;

    for (var i=0;i<poeFixedValues.length;i++) {
      matrix [i+1] = [poeFixedValues[i], 'None', 'None', 'None', 'None', 'None', 'None'];
    }

    var csv = '',
    rows = this.getDataRows(),
    csvOptions = this.options.exporting.csv,
    decimalPoint = pick(csvOptions.decimalPoint, csvOptions.itemDelimiter !== ',' && useLocalDecimalPoint ?
      (1.1).toLocaleString()[1] :
      '.'),
    itemDelimiter = pick(csvOptions.itemDelimiter, decimalPoint === ',' ? ';' : ','),
    lineDelimiter = csvOptions.lineDelimiter;

    rows.forEach(function(row, j) {
      if (j > 1) {
        for (var i=0;i<poeFixedValues.length;i++) {
          if (row[row.length - 1] === poeFixedValues[i]) {
            if (row.length <= columns.length) {
              matrix[i + 1][row.length - 1] = row[0];
            }
            break;
          }
        }
        // console.log(`mih: ${row[0]}, poe(${row.length - 1}): ${row[row.length - 1]}`);
      }
    });
    // console.log("ciao");

    for (var i=0; i < matrix.length; i++) {
      csv += matrix[i].join(itemDelimiter)
      if (i < matrix.length - 1) {
        csv += lineDelimiter;
      }
    }
    return csv;
  });
}(global.Highcharts));

/*
(function (H) {
   if (H.getOptions().exporting) {
    H.Chart.prototype.downloadXLSX = function () {
      // var div = document.createElement('div'),
      //   name,
      //   xlsxRows = [],
      //   rows;
      // div.style.display = 'none';
      // document.body.appendChild(div);
      // xlsxRows = rows.slice(1).map(function (row) {
      //   return row.map(function (column) {
      //     return {
      //       type: typeof column === 'number' ? 'number' : 'string',
      //       value: column
      //     };
      //   });
      // });

      var rows = this.getDataRows(true);
      var name;
      var xlsxRows = [];

      // Get the filename, copied from the Chart.fileDownload function
      if (this.options.exporting.filename) {
        name = this.options.exporting.filename;
      } else if (this.title && this.title.textStr) {
        name = this.title.textStr.replace(/ /g, '-').toLowerCase();
      } else {
        name = 'chart';
      }


      var matrix = [[]];
      const poeFixedValues = [
        1.0, 0.5, 0.2, 0.1, 0.05, 0.02, 0.01, 0.005, 0.002, 0.001, 0.0005]; // , 0.0002, 0.0001, 0.00005, 0.00002];

      var columns = ['poe', 'mih_mean', 'mih_p02', 'mih_p16', 'mih_p50', 'mih_84', 'mih_98']
      matrix [0] = columns;

      for (var i=0;i<poeFixedValues.length;i++) {
        matrix [i+1] = [poeFixedValues[i], 'None', 'None', 'None', 'None', 'None', 'None'];
      }

      rows.forEach(function(row, j) {
        if (j > 1) {
          for (var i=0;i<poeFixedValues.length;i++) {
            if (row[row.length - 1] === poeFixedValues[i]) {
              if (row.length <= columns.length) {
                matrix[i + 1][row.length - 1] = row[0];
              }
              break;
            }
          }
          // console.log(`mih: ${row[0]}, poe(${row.length - 1}): ${row[row.length - 1]}`);
        }
      });

      // xlsxRows = matrix.slice().map(function (row) {
      //   return row.map(function (column) {
      //     return {
      //       type: typeof column === 'number' ? 'number' : 'string',
      //       value: column
      //     };
      //   });
      // });

      // var buffer = xlsx.build([{name: 'name', data: matrix}]);

      // zipcelx({
      //   filename: name,
      //   sheet: {
      //     data: xlsxRows
      //     // data: xlsxRows
      //     // data: [[{type: 'string', value: 'ciao'}]]
      //   }
      // });

      // Create a new instance of a Workbook class
      var workbook = new excel.Workbook();

      // Add Worksheets to the workbook
      var worksheet = workbook.addWorksheet('Sheet 1');
      worksheet.cell(1,1).number(100);

      // return await new Promise((resolve, reject)=>{
      //   workbook.writeToBuffer().then(buffer => {
      //     resolve(buffer);
      //   }).catch(error =>{
      //     reject(error);
      //   });
      // })
    };

    // Default lang string, overridable in i18n options
    H.getOptions().lang.downloadXLSX = 'Download XLSX';

    // Add the menu item handler
    H.getOptions().exporting.menuItemDefinitions.downloadXLSX = {
      textKey: 'downloadXLSX',
      onclick: function () {
        this.downloadXLSX();
      }
    };

    // Replace the menu item
    var menuItems = H.getOptions().exporting.buttons.contextButton.menuItems;
    menuItems[menuItems.indexOf('downloadXLS')] = 'downloadXLSX';
   }

}(global.Highcharts));
*/

@inject('dataStore')
@observer
class Map extends React.Component {
  static propTypes = {
    dataStore: PropTypes.object.isRequired,
  };
  constructor() {
    super();
    // this.markerBounds = [];

    // this.markerBounds = [
    //   [-180, -180],
    //   [180, 180]
    // ];

    this.state = {
      lat: 37,
      lng: 17,
      zoom: 5,
    };

    // bea-zoom
    // this.state = {
    //   open: false,
    //   bounds: null,
    //   lat: 37,
    //   lng: 17,
    //   zoom: 5,
    // };
    // this.mapRef = createRef();
    // this.groupRef = createRef();
  }

componentDidMount() {
  const { map } = this._map.contextValue;
  const { dataStore } = this.props;


  L.easyPrint({
    title: 'Print',
    position: 'topleft',
    sizeModes: ['Current', 'A4Portrait', 'A4Landscape'],
    filename: `${dataStore.currentMaptype}-${dataStore.currentStatistic}-${dataStore.currentMihPoe}`,
  }).addTo(map);

  L.easyPrint({
    title: 'Export as PNG',
    position: 'topleft',
    sizeModes: ['Current', 'A4Portrait', 'A4Landscape'],
    exportOnly: 'true',
    filename: `${dataStore.currentMaptype}-${dataStore.currentStatistic}-${dataStore.currentMihPoe}`,
  }).addTo(map);

  const logo = L.control({ position: 'bottomleft' });
  logo.onAdd = function() {
    const div = document.getElementsByClassName('map-credit')[0];
    return div;
  };
  logo.addTo(map);

  // =========================
  // if (circleInfo.length !== 0) {
  //   if (circleInfo[0].length && circleInfo[0].length > 0) {
  //     var markerBounds = [];
  //     circleInfo[0].forEach(marker => {
  //       markerBounds.push([marker[0], marker[1]])
  //     })
  //     props.map.fitBounds(markerBounds)
  //   }
  // }

  // var markerBounds = [];
  // markerBounds.push([-1, 1])
  // markerBounds.push([-2, 2])
  // map.fitBounds(markerBounds)

  //=======================

  // bea-zoom https://codesandbox.io/s/how-to-call-fitbounds-and-getbounds-in-react-leaflet-1m50m?file=/src/Map.js
  // const mapRef = useRef(null);
  // if (this.mapRef.current) {
  //   let mapInst = this.mapRef.current.leafletElement;
  //   const group = this.groupRef.current.leafletElement; //get native featureGroup instance
  //   mapInst.fitBounds(group.getBounds());
  // }

  // var markerBounds = [];
  // this.markerBounds.push([this.props.dataStore.currentDatasetMinLat - 0.5, this.props.dataStore.currentDatasetMinLng - 0.5]);
  // this.markerBounds.push([this.props.dataStore.currentDatasetMaxLat + 0.5, this.props.dataStore.currentDatasetMaxLng + 0.5]);


  // this.markerBounds = [
  //   [this.props.dataStore.currentDatasetMinLat - 0.5, this.props.dataStore.currentDatasetMinLng - 0.5],
  //   [this.props.dataStore.currentDatasetMaxLat + 0.5, this.props.dataStore.currentDatasetMaxLng + 0.5]
  // ];
}

onZoomEnd = e => {
  this.setState({
    zoom: e.target._zoom,
  });
};

getClickedLoc = (e, poiCode) => {

  this.props.dataStore
    .getNearestPoi([poiCode, this.props.dataStore.currentDataset])
    .then(result => {
      this.props.dataStore.setCurveData(result.content);
    });
};


// onMouseOver = (e) => {
//   console.log('onMouseOver', e)
// }
//
// onMouseOut = (e) => {
//   console.log('onMouseOut', e)
// }
//
render() {
  const position = [this.state.lat, this.state.lng];
  const opacityDecreaseStyle = { opacity: '0.3' };

  console.log("vediamo le circeinfo")
  console.log(this.props.dataStore.circlesInfo)

  return (

    <div className="map__wrapper">
      <Spin
        spinning={this.props.dataStore.loadingMap}
        tip="Loading..."
        style={{ zIndex: 1000, position: 'absolute' }}
      />
      <LeafletMap
        // bea-zoom
        // ref={this.mapRef}
        ref={c => (this._map = c)}
        id="map"
        // minZoom={3}
        // maxZoom={8}
        doubleClickZoom={false}
        // wheelPxPerZoomLevel={150}
        zoomSnap={0}
        zoomDelta={0.25}
        bounds={this.props.dataStore.markerBounds}
        //maxBounds={[[-6.5, -54], [78.9, 116.7]]}
        onZoomEnd={this.onZoomEnd}
        style={this.props.dataStore.loadingMap ? opacityDecreaseStyle : null}
        center={
          this.props.dataStore.markerLoc
            ? [this.props.dataStore.markerLoc[0], this.props.dataStore.markerLoc[1]]
            : position
        }
        // onClick={this.getClickedLoc}
        // zoom={this.state.zoom}
      >
        <TileLayer
          attribution="&copy; <a href=&quot;http://www.ingv.it/&quot;>INGV</a> All rights reserved."
          url="https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}"
        />
        <Circles map={this} circleData={this.props.dataStore.circlesInfo} />

        {this.props.dataStore.markerLoc && this.props.dataStore.isModalActive ? (
          <Marker
            position={[this.props.dataStore.markerLoc[0], this.props.dataStore.markerLoc[1]]}
            title="Active Point of Interest"
            draggable="true"
          >
          </Marker>
        ) : null}

      </LeafletMap>
      <div className="map-credit">
        {this.props.dataStore.currentLogoURL !== '' ? (
          <img
            style={{ height: 60, opacity: 0.8 }}
            alt="map credit"
            src={`${this.props.dataStore.currentLogoURL}`}
            // src={`https://gnssdata-epos-ring.ingv.it:8080/${this.props.dataStore.currentLogoURL}`}
          />
        ) : null}
      </div>
      <div className="draggable-legend">
        <Rnd
          default={{
            x: -5,
            y: -278,
            width: 140,
          }}
          enableResizing={false}
          bounds="body"
        >
          <div className="map-legend">
            <div className="map-legend__legendpalette" />
            <div className="map-legend__legendtext">
              {this.props.dataStore.currentMaptype === 'hazard' ? (
                <div>
                  <div style={{ position: 'absolute' }}>0.5m</div>
                  <div style={{ position: 'absolute', top: 90 }}>1m</div>
                  <div style={{ position: 'absolute', top: 150 }}>5m</div>
                  <div style={{ position: 'absolute', top: 180 }}>10m</div>
                  <div style={{ position: 'absolute', top: 210 }}>20m</div>
                  <div style={{ position: 'absolute', top: 242 }}>50m</div>
                </div>
              ) : (
                <div>
                  <div style={{ position: 'absolute' }}>0.005</div>
                  <div style={{ position: 'absolute', top: 35 }}>0.01</div>
                  <div style={{ position: 'absolute', top: 65 }}>0.02</div>
                  <div style={{ position: 'absolute', top: 110 }}>0.05</div>
                  <div style={{ position: 'absolute', top: 140 }}>0.1</div>
                  <div style={{ position: 'absolute', top: 242 }}>1</div>
                </div>
              )}
            </div>
          </div>
        </Rnd>
      </div>
      {this.props.dataStore.markerLoc && this.props.dataStore.isModalActive ? (
        <Rnd
          default={{
            x: 40,
            y: 200,
            width: 600,
            height: 370,
          }}
          minHeight={177}
          bounds="parent"
          lockAspectRatio
          dragHandleClassName="chart__drag-handler"
          enableResizing={{
            top: false,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true,
          }}
          style={{
            zIndex: 1000,
            position: 'absolute',
            backgroundColor: 'white',
            borderRadius: '5px',
            boxShadow: '0px 0px 20px -1px rgba(0,0,0,0.67)',
          }}
          onResize={() => {
            this.forceUpdate();
          }}
        >
          <div className="chart__drag-handler">
            <div style={{ cursor: 'default' }}>
              <Popover style={{ backgroundColor: 'black' }} content={curveInfoContent}>
                <Icon style={{ fontSize: 16 }} type="info-circle" />
              </Popover>
            </div>
            <div>
              <Icon style={{ fontSize: 20 }} type="ellipsis" />
            </div>
            <div onClick={() => this.props.dataStore.closeCurveModal()} style={{ cursor: 'default' }}>
              <Icon style={{ fontSize: 20 }} type="close" />
            </div>
          </div>
          <Divider />
          <div className="chart__wrapper">
            <Lines
              poi={this.props.dataStore.markerLoc}
              poiCode={this.props.dataStore.poiCode}
              meanPoeData={this.props.dataStore.meanPoeArray}
              p02PoeData={this.props.dataStore.p02PoeArray}
              p16PoeData={this.props.dataStore.p16PoeArray}
              p50PoeData={this.props.dataStore.p50PoeArray}
              p84PoeData={this.props.dataStore.p84PoeArray}
              p98PoeData={this.props.dataStore.p98PoeArray}
              meanMihData={this.props.dataStore.meanMihArray}
              p02MihData={this.props.dataStore.p02MihArray}
              p16MihData={this.props.dataStore.p16MihArray}
              p50MihData={this.props.dataStore.p50MihArray}
              p84MihData={this.props.dataStore.p84MihArray}
              p98MihData={this.props.dataStore.p98MihArray}
            />
          </div>
        </Rnd>
      ) : null}
    </div>
  );
}
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map.js